module.exports = __webpack_public_path__ + "img/MdContent4.287570e4.png";